import { InjectionToken } from '@angular/core';

// derived from the package.json version during the build process
declare let TELLENT_CLIENT_VERSION: string;

export const AppRevisionToken = new InjectionToken('APP_REVISION');
export const AppRevisionProvider = {
  provide: AppRevisionToken,
  useValue: TELLENT_CLIENT_VERSION,
};
